import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy brand-hub leaf → brand workbench drawer (full mode,
// overview tab). See the brand workbench design doc (CommitMind). Kept as a
// redirect so post-onboarding deep links + bookmarks survive.
export const Route = createFileRoute('/brand/$slug/_brand/summary')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/brand/$slug/home',
      params: { slug: params.slug },
      search: { brand: 'full', brandTab: 'overview' },
    });
  },
});
